import gql from "graphql-tag";
const LOGIN_MUTATION = gql`
  mutation signin($signInData: SignInInput!) {
    signin(signInData: $signInData) {
      accessToken
      refreshToken
      username
      isTwoFaEnabled,
      twoFaToken
      firstname
      surname
    }
  }
`;

export default LOGIN_MUTATION;
